import { ConfigModule } from 'shared/types'
import { controls } from 'shared/components/controls'
import TestSpeechControl from 'display/components/controls/TestSpeech.vue'
export interface ServicesConfig {
	awsRegion: string
	awsIdentityPoolId: string
	eliminationTemplate: string
	paceToBeatTemplate: string
	voice: string
	sampleRate: string
	engine: string
	// videoSource1: string
	// videoSource2L: string
	// videoSource2R: string
	// videoSource3L: string
	// videoSource3M: string
	// videoSource3R: string
}

import './blob'
declare module './blob' {
	interface ConfigBlob {
		servicesConfig: ServicesConfig
	}
}

export const servicesConfig: ConfigModule<ServicesConfig> = {
	page: '',
	panel: 'Services',
	isTheme: false,
	fields: {
		awsRegion: {
			default : ''
		},
		awsIdentityPoolId: {
			default: ''
		},
		eliminationTemplate: {
			default:  `<speak>NAME eliminated!</speak>`,
			private: true,
			control: {
				component: 'testSpeech',
				label: 'Elimination Template',
			},
			hideDuringRace: true
		},
		paceToBeatTemplate: {
			default: `<speak>Pace to beat is now M:SS</speak>`,
			private: true,
			control: {
				component: 'testSpeech',
				label: 'Pace to Beat Template',
			},
			hideDuringRace: true
		},
		voice: {
			default:  `Matthew`,
			private: true,
			control: controls.Select('Voice', {
				Matthew: 'Matthew'
			})
		},
		sampleRate: {
			default: '22050',
			private: true,
			hideDuringRace: true,
			control: controls.Select('Sample Rate', ['8000', '16000', '22050', '24000'])
		},
		engine: {
			default: 'neural',
			private: true,
			hideDuringRace: true,
			control: controls.Select('Engine', ['standard', 'generative', 'long-form', 'neural'])
		},
		// videoSource1: {
		// 	default:  `http://files.concept2.com/v3/1.mp4`,
		// 	private: false,
		// 	control: controls.Text('One Camera - Video Url'),
		// 	hideDuringRace: false
		// },
		// videoSource2L: {
		// 	default:  `http://files.concept2.com/v3/1.mp4`,
		// 	private: false,
		// 	control: controls.Text('Two Cameras - Left Video Url'),
		// 	hideDuringRace: false
		// },
		// videoSource2R: {
		// 	default:  `http://files.concept2.com/v3/1.mp4`,
		// 	private: false,
		// 	control: controls.Text('Two Cameras - Right Url'),
		// 	hideDuringRace: false
		// },
		// videoSource3L: {
		// 	default:  `http://files.concept2.com/v3/1.mp4`,
		// 	private: false,
		// 	control: controls.Text('Three Cameras - Left Url'),
		// 	hideDuringRace: false
		// },
		// videoSource3M: {
		// 	default:  `http://files.concept2.com/v3/1.mp4`,
		// 	private: false,
		// 	control: controls.Text('Three Cameras - Middle Url'),
		// 	hideDuringRace: false
		// },
		// videoSource3R: {
		// 	default:  `http://files.concept2.com/v3/1.mp4`,
		// 	private: false,
		// 	control: controls.Text('Three Cameras - Right Url'),
		// 	hideDuringRace: false
		// }

	}
}
